module.exports = __webpack_public_path__ + "img/acwy.3e571ac9.png";